export function knowledgeHubUrl(org: string): string {
  return `https://knowledge${import.meta.env?.VITE_SERVICE_ENVIRONMENT}.changeengine.com/?org=${org}`;
}
